import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import * as _ from 'lodash';
import { Certification, CacheService } from "mapfre-auditlib";
import { map } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})

export class CertificationService {

  className = 'CertificationService'

  constructor(private http: HttpClient, private cacheService: CacheService) { }

  getAllCertifications(cache = true, cacheKey = "allCertifications"): Observable<Certification[]>| any {
    if (this.cacheService.canUseCache(cacheKey) && cache) {
      return this.cacheService.getCacheData(cacheKey);
    } else {
      let observable = this.http.get<Certification[]>(environment.base_URL + "/types-certifications").pipe(map((res) => {
      this.cacheService.updateCacheData(res, cacheKey)
      return res;
      }))
      this.cacheService.updateCacheReq(cacheKey);
      return observable;
    }
  }

  newCertification(certification) {
    return this.http.post(environment.base_URL + "/types-certifications", certification)
  }

  updateCertification(certification, id) {
    return this.http.put(environment.base_URL + `/types-certifications/${id}`, certification)
  }
}

